<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="活动名称" prop="activityName" >
        <a-input v-model="form.activityName" placeholder="请输入活动名称" />
      </a-form-model-item>
      <a-form-model-item label="开始日期" prop="startDate" >
        <a-date-picker style="width: 100%" v-model="form.startDate" format="YYYY-MM-DD" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="结束日期" prop="endDate" >
        <a-date-picker style="width: 100%" v-model="form.endDate" format="YYYY-MM-DD" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="点赞达标门槛" prop="likeThreshold" >
        <a-input-number style="width: 100%" v-model="form.likeThreshold" placeholder="请输入点赞达标门槛数量" :min="0" :precision="0" />
      </a-form-model-item>
      <a-form-model-item label="视频达标奖励金额" prop="videoLikeExtraReward" >
        <a-input-number style="width: 100%" v-model="form.videoLikeExtraReward" placeholder="请输入视频点赞达标后奖励金额" :min="0" :precision="2" />
      </a-form-model-item>
      <a-form-model-item label="文章达标奖励金额" prop="articleLikeExtraReward" >
        <a-input-number style="width: 100%" v-model="form.articleLikeExtraReward" placeholder="请输入文章点赞达标后奖励金额" :min="0" :precision="2" />
      </a-form-model-item>
      <a-form-model-item label="发布视频奖励金额" prop="firstVideoReward" >
        <a-input-number style="width: 100%" v-model="form.firstVideoReward" placeholder="请输入医师发布视频现金奖励金额" :min="0" :precision="2" />
      </a-form-model-item>
      <a-form-model-item label="奖金总额" prop="totalAmount" >
        <a-input-number style="width: 100%" v-model="form.totalAmount" placeholder="请输入活动奖金总额" :min="0" :precision="2" />
      </a-form-model-item>
      <a-form-model-item label="活动规则说明" prop="content" >
        <a-input v-model="form.content" placeholder="请输入活动规则说明" type="textarea" :rows="4" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="活动状态" prop="status" >
        <a-select v-model="form.status" placeholder="请选择活动状态">
          <a-select-option :value="0">开启</a-select-option>
          <a-select-option :value="1">关闭</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getActivity, addActivity, updateActivity } from '@/api/videoreward/activity'
import moment from "moment";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        activityName: null,
        startDate: null,
        endDate: null,
        likeThreshold: null,
        videoLikeExtraReward: null,
        articleLikeExtraReward: null,
        firstVideoReward: null,
        totalAmount: null,
        content: null,
        status: 0,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        activityName: [
          { required: true, message: '活动名称不能为空', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '开始日期不能为空', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '结束日期不能为空', trigger: 'change' }
        ],
        likeThreshold: [
          { required: true, message: '点赞达标门槛不能为空', trigger: 'blur' }
        ],
        videoLikeExtraReward: [
          { required: true, message: '视频达标奖励金额不能为空', trigger: 'blur' }
        ],
        articleLikeExtraReward: [
          { required: true, message: '文章达标奖励金额不能为空', trigger: 'blur' }
        ],
        firstVideoReward: [
          { required: true, message: '发布视频奖励金额不能为空', trigger: 'blur' }
        ],
        totalAmount: [
          { required: true, message: '奖金总额不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        activityName: null,
        startDate: null,
        endDate: null,
        likeThreshold: null,
        videoLikeExtraReward: null,
        articleLikeExtraReward: null,
        firstVideoReward: null,
        totalAmount: null,
        content: null,
        status: 0,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加医生内容发布激励活动'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getActivity({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改医生内容发布激励活动'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.startDate > this.form.endDate) {
            this.$message.error(
              '开始日期不能大于结束日期',
              3
            )
            return
          }
          this.form.startDate = moment(this.form.startDate).format("YYYY-MM-DD")
          this.form.endDate = moment(this.form.endDate).format("YYYY-MM-DD")
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateActivity(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addActivity(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
